export const FONT_SIZE_EXTRALARGE = 21;
export const FONT_SIZE_LARGE = 18;
export const FONT_SIZE_MEDIUM = 15;
export const FONT_SIZE_REGULAR = 13;
export const FONT_SIZE_SMALL = 11.5;

export const LETTER_SPACING_TIGHT = '-0.2px';
